// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { forgotPasswordService } from './service';
import * as forgotPasswordActions from './actions';
import * as types from './actionTypes';

function* forgotPasswordSaga(payload) {
  const result = yield call(forgotPasswordService, payload);
  if (result.ok) {
    const res = result.body.ForgotPasswordResult;
    if (res) {
      yield put(forgotPasswordActions.submitForgotPasswordSuccess());
    } else {
      yield put(forgotPasswordActions.submitForgotPasswordFailed());
    }
  }
}

const forgotPasswordSagas = [
  takeEvery(types.SUBMIT_FORGOT_PASSWORD, forgotPasswordSaga),
];

export default forgotPasswordSagas;
